import { usePageEventTracker } from '@insify/objectiv';
import { ContentContextWrapper } from '@objectiv/tracker-react';
import { type ComponentType } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';

import { PageTransition } from '../PageTransition';
import { PageTransitionProvider } from '../PageTransition/PageTransitionProvider';

import { UseWizardWithoutRouterProvider, type UseWizardWithoutRouterProviderProps } from './hooks/useWizard';

import type { Location } from 'react-router-dom';

export type WizardStep<Slug = string> = {
  Page: ComponentType;
  slug: Slug;
};

type WizardWithoutRouterProps = {
  Fallback: ComponentType;
  contentLogo?: React.ReactNode;
} & Omit<UseWizardWithoutRouterProviderProps, 'children'>;
/** This version is for frontends that have their own react router BrowserRouter component */
export const WizardWithoutRouter = ({
  contentLogo,
  Fallback,
  ...wizardPageProps
}: WizardWithoutRouterProps): JSX.Element => {
  const location = useLocation();

  usePageEventTracker(wizardPageProps.steps);
  return (
    <PageTransitionProvider>
      <UseWizardWithoutRouterProvider {...wizardPageProps}>
        <PageTransition<Location> location={location}>
          {(location) => (
            <Routes location={location}>
              {wizardPageProps.steps.map(({ slug, Page }) => {
                return (
                  <Route
                    key={slug}
                    path={slug}
                    element={
                      <ContentContextWrapper id={slug}>
                        {contentLogo}
                        <Page />
                      </ContentContextWrapper>
                    }
                  />
                );
              })}
              <Route path='*' Component={Fallback} />
            </Routes>
          )}
        </PageTransition>
      </UseWizardWithoutRouterProvider>
    </PageTransitionProvider>
  );
};
